export const CURRENT_AGREEMENT_VERSION = "1.0";
